import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { dateConvert } from "../../common/Helpers";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { nahlasenieDodavkyController } from "../../../controllers/nahlaseniedodavky.controller";

class NahlasenieRozdiely extends Component {
    state = { items: [], loading: true };

    shouldComponentUpdate(nextProps) {
        if (this.props.idNahlasenie !== nextProps.idNahlasenie) {
            this.getNahlasenieRozdielyByIdNahlasenie(nextProps.idNahlasenie);
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.getNahlasenieRozdielyByIdNahlasenie(this.props.idNahlasenie);
    }

    getNahlasenieRozdielyByIdNahlasenie(idNahlasenie) {
        nahlasenieDodavkyController.getNahlasenieRozdiely(idNahlasenie).then(ajaxData => {
            let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
            this.setState({
                items: data,
                loading: false
            });
        });
    }

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="NahlasenieRozdiely">
                <Grid
                    data={items}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}>
                    <GridColumn
                        field="ciarovyKod"
                        title={localizationService.toLanguageString("NahlasenieRozdiely.Grid.Balík/Lot", "Balík/Lot")}
                        width="80px"
                    />
                    <GridColumn
                        field="textArtikel"
                        title={localizationService.toLanguageString("NahlasenieRozdiely.Grid.Zistené rozdiely", "Zistěné rozdiely")}
                    />
                    <GridColumn
                        field="pocetKs"
                        title={localizationService.toLanguageString("NahlasenieRozdiely.Grid.Rozdiel  ks", "Rozdiel ks")}
                        width="80px"
                    />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default NahlasenieRozdiely;

registerForLocalization(NahlasenieRozdiely);



// WEBPACK FOOTER //
// ./src/components/dialogs/NahlasenieDodavky/NahlasenieRozdiely.js